export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8819.b9d837d2.jpg";